module.exports = __webpack_public_path__ + "img/errorIcon.cde65be3.svg";